module.exports = __webpack_public_path__ + "img/comment.fa335777.svg";